module.exports = __webpack_public_path__ + "img/canada-skin-connective-and-musculoskeletal-diseases-male.133526b3.png";